import { Address } from "viem";

export interface UnderWritingToken {
    address: Address,
    symbol: string
}

export const underwritingToken: UnderWritingToken = {address: '0x362bbce159C14060c045565fF31d2b7d1282bf35', symbol: "wstETH"};